import footerStyles from "../styles/footer.module.css";

function Footer() {
  return (
    <div className={footerStyles.footer}>
      @VerbalMate AI
    </div>
  );
}

export default Footer;
